import { render, staticRenderFns } from "./ListSocieties.vue?vue&type=template&id=38e10f33&"
import script from "./ListSocieties.vue?vue&type=script&lang=js&"
export * from "./ListSocieties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports